import clsx from "clsx"
import React, { memo } from "react"
import type { FC } from "react"

type Props = {
  isActive: boolean
  onClick: () => void
  title: string
}

const TabItemComponent: FC<Props> = ({ isActive, onClick, title }) => {
  return (
    <div className={clsx("tab-item", { active: isActive })} onClick={onClick}>
      <span className={clsx("tab-item-title", { active: isActive })}>{title}</span>
    </div>
  )
}

export const TabItem = memo(TabItemComponent)
